import { Alert, Box, styled } from '@mui/material';
import { chromeYellow, spaceCadet, ultraMarine } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  border: `1px solid ${spaceCadet[300]}`,
  padding: 8,
  borderRadius: 4,
  '& .MuiBox-root.cta': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    '& > .MuiButton-root': {
      textTransform: 'none',
    },
    '& > .MuiTypography-body1': {
      fontSize: 14,
    },
  },
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& > .MuiBox-root': {
    '& .markdown': {
      fontSize: 14,
      lineHeight: '24px',
    },
    '& > .MuiButton-containedSizeSmall': {
      padding: '8px',
      fontSize: 14,
      gap: 4,
      '& .MuiSvgIcon-root': {
        fontSize: 16,
      },
    },
  },
});

export const StyledTranscriptAlert = styled(Alert)({
  padding: '4px 8px',
  '&.MuiAlert-standardWarning': {
    color: chromeYellow[600],
    backgroundColor: chromeYellow[100],
    border: `1px solid ${chromeYellow[300]}`,
  },
  '&.MuiAlert-standardInfo': {
    color: ultraMarine[600],
    backgroundColor: ultraMarine[100],
    border: `1px solid ${ultraMarine[300]}`,
  },
  '& > .MuiAlert-message': {
    fontSize: 14,
    fontWeight: 500,
    '& > .MuiAlertTitle-root': {
      fontSize: 14,
      fontWeight: 600,
    },
    '& > .MuiList-root': {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '& > .MuiListItem-root': {
        padding: 0,
        display: 'flex',
        gap: 4,
        '& > .MuiListItemIcon-root': {
          padding: 0,
          minWidth: 0,
          color: 'inherit',
          '& > .MuiSvgIcon-root': {
            fontSize: 6,
          },
        },
      },
    },
  },
  '& .MuiAlert-icon': {
    fontSize: 18,
    color: 'inherit',
  },
});

export default StyledBox;
